import { render, staticRenderFns } from "./policyInfo.vue?vue&type=template&id=08d4a4b0&"
import script from "./policyInfo.vue?vue&type=script&lang=js&"
export * from "./policyInfo.vue?vue&type=script&lang=js&"
import style0 from "./policyInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports